<div class="card" [ngClass]="{ 'container-fluid': mobileMode(), 'p-0': mobileMode() }"
  [style.background-color]="clozeTestStyleModel().exerciseBackground" [ngStyle]="{
        border: mobileMode() ? '0' : '1px solid ' + clozeTestStyleModel().frameColor,
        'border-radius': mobileMode() ? '0' : '8px',
        width: mobileMode() ? '' : '720px',
      }">
  <div class="card-body pb-1" [style.font-family]="clozeTestStyleModel().font"
    [style.font-size]="mobileMode() ? '16px' : clozeTestStyleModel().fontSize">
    @if (showResult()) {
    <div>
      @if (lang().toLowerCase() === 'en') {
      <div class="card-title-row">
        <h4 class="card-title">Well done!</h4>
      </div>
      <p class="card-text">
        The test is completed. You achieved: {{ results().score }} points<br /><br />
        This is {{ results().score / results().maxScore | percent: "1.0-0" }} of the maximum possible
        {{ results().maxScore }} points.<br /><br />
      </p>
      <p class="card-text">
        The test result allows a classification according to the global scale of the Common European Framework of
        Reference up to a maximum of B2 or higher. Your level is:<br /><br />
      </p>
      <p class="card-text"><b>{{ results().graduation }}</b></p><br />
      <p class="card-text">
        You can now transfer this result to your Study Guide and your further tasks will be adjusted accordingly.
      </p>
      } @else {
      <div class="card-title-row">
        <h4 class="card-title">Super, geschafft!</h4>
      </div>
      <p class="card-text">
        Der Test ist beendet. Du hast folgendes Ergebnis erzielt: {{ results().score }} Punkte<br /><br />
        Dies sind {{ results().score / results().maxScore | percent: "1.0-0" }} der maximal möglichen
        {{ results().maxScore }} Punkte.<br /><br />
      </p>
      <p class="card-text">
        Das Testergebnis erlaubt eine Einstufung analog zur globalen Skala des Gemeinsamen Europäischen
        Referenzrahmens bis maximal B2 oder höher. Die Einstufung lautet:<br /><br />
      </p>
      <p class="card-text"><b>{{ results().graduation }}</b></p><br />
      <p class="card-text">
        Dieses Ergebnis kannst du nun in deinen Study Guide übernehmen, und deine weiteren Aufgaben werden
        dementsprechend angepasst.
      </p>
      }

      <div class="d-flex justify-content-end" style="margin-top: 30px">
        <button class="btn" style="font-size: smaller" [style.background-color]="cTestButtonColor()"
          (click)="closeTab()">
          @if (lang().toLowerCase() === 'en') { Close tab } @else { Tab schließen }
          <i class="fas fa-arrow-right ms-2"></i>
        </button>
      </div>
    </div>
    } @else {
    <div>
      @if (lang().toLowerCase() === 'en') {
      The test has been completed.
      } @else {
      Der Test ist abgeschlossen.
      }
    </div>
    }

    @if (showEndTestButton()) {
    <div class="text-center" style="margin-top: 30px">
      <button class="btn" [style.background-color]="cTestButtonColor()" (click)="onClozeTest()">
        @if (lang().toLowerCase() === 'en') {
        End test
        } @else {
        Test beenden
        }
      </button>
    </div>
    }
  </div>
</div>